import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import CodaTable from '@accounting/components/tables/coda-table/coda-table.vue';

@Component({
  name: 'bpc-codas',
  components: {
    'bpc-coda-table': CodaTable,
  },
})
export default class Codas extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
